import fastDeepEqual from 'fast-deep-equal';

export function equals(a, b) {
  return fastDeepEqual(a, b);
}

export function notEquals(a, b) {
  return !equals(a, b);
}
